import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface DreamDialogProps extends HelpDialogLayoutProps {
}
export default function DreamDialog(props: DreamDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            夢の大事な役割
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "夢は未解明の部分が多い分野ですが、近年の研究により少しずつその役割が明らかになってきています。夢を見ることは脳の重要な働きの一つであり、特に夢を見ることが多いレム睡眠中には記憶の整理や感情の処理が行われると考えられています。また、ノンレム睡眠中にも夢を見ることがあることが最近の研究でわかってきました。",
              ]}
            />
            <BodyTypographies
              contents={[
                "人は一晩のうちに複数の夢を見るのが普通であり、夢を見ること自体は健康的な現象です。ただし、夢と一緒に目が覚めてしまうことが多い場合は、中途覚醒が多くなり、睡眠の質に影響を与える可能性があります。覚えている夢の多くは目覚める直前のものであるため、「たくさん夢を見た」と感じる場合は、実際には何度も目が覚めている可能性も考えられます。",
              ]}
            />
            <BodyTypographies
              contents={[
                "この点に注目し、SLEEP COMPASSでは「睡眠効率」という指標を用いて、夢と睡眠の質の関係を評価しました。",
                "夢を見ることは脳にとって良い働きをもたらしますが、目が覚めてしまっている場合は覚醒を減らすよう改善することが大切です。",
              ]}
            />
          </ContentStack>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2" color="#3D3D3D">
            悪夢を見る
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "悪夢を見ることもよくあることで特に心配はありません。",
                "しかし、悪夢ばかりを継続的に見ている場合は、何らかストレスを感じている可能性があるため、就寝前にストレスを軽減させるようにしましょう。",
                "例えば、ナイトルーチンとして、入浴、ストレッチやヨガ、音楽やアロマなど自分がリラックスできるものを取り入れてみましょう。",
                "また、考え事や不安を紙に書き出すことも有効です。「書く」行為はシンプルながら、感情の浄化作用が強く、また感情を客観視したり新しい視点でとらえる機会ともなり、不安が改善し、ストレスが大幅に軽減することが心理学や社会学にて報告されています。",
                "日中の適度な運動もストレス耐性を高める効果的な手段です。覚醒を減らす効果もあるため、活用してみてください。",
              ]}
            />
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
